<template>
    <div class="">
        <label :class="light ? 'text-gray-200' : 'text-gray-800'" class=" block text-sm font-medium text-gray-600">{{label}}</label>
        <div class="relative select-none">
            <div  class="bg-white rounded-md border border-gray-300 overflow-hidden divide-x">                            
                <!-- options select -->
                <div class="text-sm flex flex-col gap-1 h-full overflow-y-auto px-1 pt-3 pb-2">
                    <label class="block text-sm text-gray-900 flex items-center" v-for="option in options" :key="option.id">
                        <div class="w-min">
                            <input @click="setSelectedOption(option)" :checked="selectedOptions.some(selectedOption => selectedOption.id === option.id)" type="checkbox" class="mx-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                        </div>
                        <p class="mb-1">
                            {{option.text}}
                        </p>
                    </label>
                </div>            
            </div>
        </div>
    </div>
    </template>
    
    <script>
    
    export default {
        name: 'CustomCheckboxButton',

        components: {
    
        },
        props: {
            label: String,
            options: Array,
            modelValue: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                showCheckbox: false,
                selectedOptions: [],
            }
        },
        methods: {
            handleClickAway() {
                this.showCheckbox = false;
            },
            setSelectedOption(option) {
                let filterOptions = (option) => {
                    if (this.selectedOptions.length < 1) return this.selectedOptions.push(option);
                    this.selectedOptions.forEach((selectedOption, index) => {
                        if (selectedOption.id === option.id) return this.selectedOptions.splice(index, 1);
                        if (index === this.selectedOptions.length - 1) return this.selectedOptions.push(option);	
                    })
                };
                filterOptions(option);
                this.$emit('update:modelValue', this.selectedOptions);
            },
            filterOptions() {
                this.selectedOptions = [...this.options.filter(option => {
                    return this.modelValue.some(value => value.id === option.id)
                })]
            }
        },
        watch: {
            modelValue: {
                deep: true,
                handler() {
                    this.filterOptions();
                }
            },
            options: {
                deep: true,
                handler() {
                    this.filterOptions();
                }
            }
            
            
            
            
            
            
            
        },
        created() {
            this.selectedOptions = [...this.options.filter(option => {
                return this.modelValue.some(valueOption => valueOption.id === option.id)
            })]
        }
    
    }
    </script>